import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() =>
  createStyles({
    box: {
      position: "absolute" as "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: 600,
    },
    pdf: {
      width: "100%",
      height: "100%",
    },
    textPages: {
      color: "#FFFFFF",
      fontSize: "14px",
    },
    grid: {
      backgroundColor: "#308CDB",
      borderRadius: "15px",
      marginTop: "10px",
    },
    loadingProgress: {
      color: "#308CDB",
    },
  })
);

export default useStyles;
